export const PROPERTY_TYPES = [
  {
    value: "NOT_APPLICABLE",
    label: "Not Applicable",
  },
  {
    value: "RESIDENTIAL",
    label: "Residential",
  },
  {
    value: "COMMERCIAL",
    label: "Commercial",
  },
  {
    value: "AGRICULTURAL",
    label: "Agricultural",
  },
];

export const PROPERTY_TYPE_LABELS = Object.fromEntries(
  PROPERTY_TYPES.map((item) => [item.value, item.label]),
);

export const getPropertyTypeLabel = (value) =>
  PROPERTY_TYPE_LABELS[value] ?? (value ? value : "Not Applicable");
